module.exports = __webpack_public_path__ + "static/media/help.ba71378c.svg";